/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'box',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M479.808,151.048c-0.032-0.264,0.064-0.52,0.008-0.784l-32-144C447.002,2.602,443.752-0.003,440,0H40
			c-3.752-0.003-7.002,2.602-7.816,6.264l-32,144c-0.056,0.264,0,0.52,0,0.8C0.103,151.372,0.042,151.685,0,152v320
			c0,4.418,3.582,8,8,8h464c4.418,0,8-3.582,8-8V152C479.956,151.679,479.892,151.361,479.808,151.048z M433.6,16l28.424,128H295.2
			L280.936,16H433.6z M215.2,16h49.6l14.232,128h-78.096L215.2,16z M200,160h80v128h-80V160z M46.4,16h152.664L184.84,144H17.976
      L46.4,16z M464,464H16V160h168v136c0,4.418,3.582,8,8,8h96c4.418,0,8-3.582,8-8V160h168V464
      
      M72,400H40c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h32c4.418,0,8-3.582,8-8v-32C80,403.582,76.418,400,72,400z
       M64,432H48v-16h16V432
       
      M152,432h-16v-36.688l10.344,10.344c3.178,3.069,8.242,2.982,11.312-0.196c2.994-3.1,2.994-8.015,0-11.116l-24-24
			c-0.745-0.747-1.632-1.337-2.608-1.736c-1.957-0.809-4.155-0.809-6.112,0c-0.976,0.399-1.863,0.989-2.608,1.736l-24,24
			c-3.07,3.178-2.982,8.242,0.196,11.312c3.1,2.994,8.015,2.994,11.116,0L120,395.312V432h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h48
      c4.418,0,8-3.582,8-8S156.418,432,152,432
      
      ${utils.rect(384, 400, 16, 16)}
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/box.js